import React, { useState, useRef, useContext } from "react";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import axiosInstance from "../../config/axiosInstance";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { ChangePasswordValidate } from "../../config/Validate";
import { Link, useNavigate } from "react-router-dom";
import { Buffer } from "buffer";

const ChangePassword: React.FC = () => {
  const navigate = useNavigate();
  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;

  // logout functionality
  const logout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const toast = useRef<any>(null);

  const [passwords, setPasswords] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState<any>({});
  const [loading, setLoading] = useState(false);

  // redirect by role
  const redirectByRole = (role: string) => {
    switch (role) {
      case "Admin":
        return "/admin-dashboard";

      case "User":
        return "/user-dashboard";

      case "Client":
        return "/client-dashboard";

      case "Employee":
        return "/employee-dashboard";

      default:
        return "/dashboard";
    }
  };

  // role
  const role = userData?.roles?.role_name;

  const handleSubmit = async () => {
    const { isError, errors } = ChangePasswordValidate(passwords);
    setErrors(errors);
    if (isError) return;

    let currentPass = Buffer.from(passwords.currentPassword).toString("base64");
    let newPass = Buffer.from(passwords.newPassword).toString("base64");
    let confirmPass = Buffer.from(passwords.confirmPassword).toString("base64");

    try {
      setLoading(true);
      const response = await axiosInstance.post(
        `/change-password/${userData?.id}`,
        {
          oldPassword: currentPass,
          newPassword: newPass,
          confirmPassword: confirmPass,
        }
      );

      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: response?.data?.message,
      });

      setPasswords({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });

      setTimeout(() => logout(), 1000);
      setErrors({});
    } catch (error: any) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AppBreadcrumb
        currentMenu="Change Password"
        pageName="Change Password"
        pageTitle={
          <>
            <Link to={redirectByRole(role)}>
              <i className="mr-2 pi pi-arrow-left"></i>
            </Link>
            Update Your Password
          </>
        }
      />

      <Toast ref={toast} />

      <div
        className="w-full p-4 surface-card shadow-2 border-round-lg"
        style={{ height: "calc(100% - 52px)" }}
      >
        <h2 className="mb-4 text-2xl font-semibold ">Change Password</h2>

        <div className="mb-3 field change_pass">
          <label className="block mb-2 font-medium">Current Password</label>
          <Password
            toggleMask
            feedback={false}
            value={passwords.currentPassword}
            onChange={(e) =>
              setPasswords({ ...passwords, currentPassword: e.target.value })
            }
            placeholder="Enter current password"
            className={errors.currentPassword ? "p-invalid w-full" : "w-full"}
          />
          {errors.currentPassword && (
            <small className="p-error">{errors.currentPassword}</small>
          )}
        </div>

        <div className="mb-3 field change_pass">
          <label className="block mb-2 font-medium">New Password</label>
          <Password
            toggleMask
            feedback={false}
            value={passwords.newPassword}
            onChange={(e) =>
              setPasswords({ ...passwords, newPassword: e.target.value })
            }
            placeholder="Enter new password"
            className={errors.newPassword ? "p-invalid w-full" : "w-full"}
          />
          {errors.newPassword && (
            <small className="p-error">{errors.newPassword}</small>
          )}
        </div>

        <div className="mb-4 field change_pass">
          <label className="block mb-2 font-medium">Confirm New Password</label>
          <Password
            toggleMask
            feedback={false}
            value={passwords.confirmPassword}
            onChange={(e) =>
              setPasswords({
                ...passwords,
                confirmPassword: e.target.value,
              })
            }
            placeholder="Confirm new password"
            className={errors.confirmPassword ? "p-invalid w-full" : "w-full"}
          />
          {errors.confirmPassword && (
            <small className="p-error">{errors.confirmPassword}</small>
          )}
        </div>

        <div className="flex justify-content-start">
          <Button
            label="Update Password"
            icon="pi pi-lock"
            className="common-primary-button"
            loading={loading}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
